import { QueryFunction } from '@tanstack/react-query';
import { getCompatibleAuthTokenHttp } from 'src/services/utils/enhancedAuthTokenHttp';
import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';

export const permissionsQueryKeyRoot = '/shared/permissions' as const;

export interface Permission {
  id: string;
  name: string;
  resourceType: string;
  action: string;
  createdAt: string;
  updatedAt: string;
}

export interface ListPermissionsResponse {
  success: boolean;
  permissions: Permission[];
}

const listPermissions: QueryFunction<
  ListPermissionsResponse,
  [typeof permissionsQueryKeyRoot, string | null]
> = async () => {
  if (isMockServices()) return await mock(_mockData);

  const authTokenHttp = await getCompatibleAuthTokenHttp();

  const response = await authTokenHttp<ListPermissionsResponse>(
    `/shared/permissions`,
    {
      method: 'GET',
    },
  );

  if (response.data) return response.data;
  throw new Error('Failed to fetch permissions');
};

export default listPermissions;

const _mockData: ListPermissionsResponse = {
  success: true,
  permissions: [
    {
      id: 'mock-1',
      name: 'Admin',
      resourceType: 'loan',
      action: 'view_all',
      createdAt: '2025-01-01T00:00:00Z',
      updatedAt: '2025-01-01T00:00:00Z',
    },
    {
      id: 'mock-2',
      name: 'User',
      resourceType: 'loan',
      action: 'view_assigned',
      createdAt: '2025-01-01T00:00:00Z',
      updatedAt: '2025-01-01T00:00:00Z',
    },
  ],
};
